<template>
	<button
		class="hamburger hamburger--slider"
		:class="{ 'is-active': active, 'light': isLight }"
		type="button"
		@click="active = !active"
		role="button"
		:aria-label="active ? 'Menü schließen' : 'Menü öffnen'"
		:aria-expanded="Boolean(active)">
		<span class="hamburger-box">
			<span class="hamburger-inner"></span>
		</span>
	</button>
</template>

<script setup lang="ts">
import { useEventListener } from '@vueuse/core'

const active = defineModel<Boolean>()
const isLight = ref(true)
const route = useRoute()

const calculateHeight = () =>
{
	if( route.meta.layout === 'page' )
	{
		return document.documentElement.scrollTop < 90
	}

	return document.documentElement.scrollTop <= window.innerHeight * .95
}
const scrollEvt = () => isLight.value = calculateHeight()

useEventListener(document, 'scroll', scrollEvt)
</script>

<style lang="css">
.hamburger.light .hamburger-inner,
.hamburger.light .hamburger-inner::after,
.hamburger.light .hamburger-inner::before
{
	background-color: rgb(var(--white))
}

.hamburger.is-active.light .hamburger-inner,
.hamburger.is-active.light .hamburger-inner:after,
.hamburger.is-active.light .hamburger-inner:before
{
	background-color: rgb(var(--white))
}
</style>